export default __webpack_public_path__ + "9f47eee87dde0ae1f5072ded5a4b8245.png";